import React, { useEffect } from "react";
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import { COLOURS } from './../styles/Colours';
import { rgba } from 'polished';
import { STYLES } from "../styles/Styles";
import CloseIcon from '../images/times-light.inline.svg';
import { Close } from "./ImageModal";
import { AnimatePresence, motion } from "framer-motion";

interface Props {
  visible: boolean;
  setIsVisible: any;
}

export const VideoModal = (props: Props) => {
  const {
    visible,
    setIsVisible
  } = props;


  let el;
  useEffect(() => {
    const el = window.document.body;
  }, []);

  return (
    <AnimatePresence>
      {visible &&

        <VideoModalWrapper
          onClick={() => setIsVisible(false)}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <Close onClick={() => setIsVisible(false)}><CloseIcon /> Close</Close>
          <VideoFrame
            src="https://www.youtube.com/embed/2vvPRoevwHw?&autoplay=1"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            frameBorder='none'
          />

        </VideoModalWrapper>

      }
    </AnimatePresence>
  )

}

const VideoModalWrapper = styled(motion.div)`
  position: fixed;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  top: ${STYLES.headerSize};
  top: 0;
  left: 0;
  background-color: ${rgba(COLOURS.charcoal, 0.9)};
  color: ${COLOURS.white};
  z-index: 99;
  @media(min-width: ${STYLES.desktopSize}) {
    padding: 2rem 8rem;
  }
`;

const VideoFrame = styled.iframe`
  width: 100%;
  @media(max-width: ${STYLES.desktopSize}) {
    height: 67.1%;
  }
  @media(min-width: ${STYLES.desktopSize}) {
    height: 100%;
    max-height: 800px;
  }
`;

